<template>

    <div class="sortable table_head_label"
        :class="{asc: (sortType == 'asc'), desc: (sortType == 'desc'), active: (isActive)}"
        @click="toggleSortName">

        <span class="sortable_label table_head_label">{{ label }}</span>
        <div class="arrows_icons">
            <i class="zmdi zmdi-chevron-up"></i>
            <i class="zmdi zmdi-chevron-down"></i>
        </div>

    </div>

</template>

<script>
export default {
    name: 'TableHeadSortable',
    props: ["label", 'isActive', "sortId"],
    components: {},
    data(){
        return {
            sortType: "asc",
        }
    },
    computed: {},
    methods: {
        toggleSortName(){
            this.sortType == 'desc' ? this.sortType = 'asc' : this.sortType = 'desc'
            this.$emit('sortChanged', this.sortType, this.sortId)
        }
    }
}
</script>

<style lang="scss" >
.sortable{
    display: flex;
    cursor: pointer;
    align-items: center;
    user-select: none;
    .arrows_icons{
        width:28px;
        display: flex;
        opacity: 0;
        font-size: 1.85rem;
        color: $info;
        margin-left: 8px;
    }
    &:hover{
        .arrows_icons{
            opacity: 1;
        }
    }
    &.active{
        .arrows_icons{
            opacity: 1;
            color: $info;
        }
        &.asc{
            .zmdi-chevron-up{
                opacity: 0;
            }
        }
        &.desc{
            .zmdi-chevron-down{
                opacity: 0;
            }
        }
    }
}

</style>